import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TranslateService } from '../services/translate/translate.service';
import { AppContextService } from '../services/app-context.service';
import { ToasterService } from '../shared-components/custom-toaster/toaster.service';
import { ServiceCallStatus } from '../models/enums/service-call-status';
import { OperationError } from '../models/server-result/operation-error';
import { ServerErrors } from '../models/enums/server-errors';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	private isHandling401 = false;

	constructor(
		private router: Router,
		private translateService: TranslateService,
		private appContext: AppContextService,
		private toasterService: ToasterService
	) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let myHeaders = new HttpHeaders();

		if (req.headers != null && req.headers.keys() != null && req.headers.keys().includes('Authorization')) {
			myHeaders = myHeaders.set('Authorization', req.headers.get('Authorization')!);
		} else {
			if (!!this.appContext && !!this.appContext.getToken()) {
				myHeaders = myHeaders.set('Authorization', 'Bearer ' + this.appContext.getToken());
				// console.log('Adding Authorization to header', req);
			}
		}

		if (req.headers != null && req.headers.keys() != null && req.headers.keys().includes('Content-Type')) {
			myHeaders = myHeaders.set('Content-Type', req.headers.get('Content-Type')!);
		} else {
			myHeaders = myHeaders.set('Content-Type', 'application/json');
			// console.log('Adding Content-Type to header', req);
		}

		if (req.headers != null && req.headers.keys() != null && req.headers.keys().includes('GoogleReCaptcha')) {
			myHeaders = myHeaders.set('GoogleReCaptcha', req.headers.get('GoogleReCaptcha')!);
		}

		const authReq = req.clone({
			headers: myHeaders,
		});
		return next.handle(authReq).pipe(
			tap({
				next: (event: HttpEvent<any>) => {
					if (event instanceof HttpResponse) {
						if (!!event.body && 'Errors' in event.body) {
							let errors = <OperationError[]>event.body.Errors;
							if (!!errors && errors.some((err) => err.Code === ServerErrors.SessionLoggedOut)) {
								this.appContext.removeSession();
								this.router.navigate(['/public/login']);
								return;
							}
						}
					}
				},
				error: (err: any) => {
					if (err instanceof HttpErrorResponse) {
						if (err.status === 403) {
							if (!!this.router.url && !this.router.url.startsWith('/public/login')) {
								this.appContext.removeSession();
								this.router.navigate(['/public/login'], {
									fragment: ServiceCallStatus.Forbidden,
								});
							} else {
								const msgCouldNotLogin = this.translateService.translate('service.call.forbidden');
								this.toasterService.showError(msgCouldNotLogin);
							}
							return;
						} else if (err.status === 401) {
							if (this.isHandling401) {
								return;
							}
							this.isHandling401 = true;

							let confirmAction = () => {
								this.isHandling401 = false;
								this.appContext.removeSession();
								this.router.navigate(['/public/login']);
							};

							this.toasterService.showWarning(
								this.translateService.translate('http-auhorization-error.modalSucessInformationContent', 'client'),
								{
									title: this.translateService.translate('http-auhorization-error.modalInformationTitle', 'client'),
									autoClose: false,
									actions: [
										{
											label: this.translateService.translate('http-auhorization-error.modalInformationConfirmActionText', 'client'),
											action: confirmAction,
										},
									],
								}
							);
						}
					}
				},
			})
		);
	}
}
